<template>
    <section class="mx-2 my-4">
        <BaseCard padding="none" radius="lgr" class="w-full min-w-0 max-w-[600px]">
            <header class="border-b border-border p-5">
                <h2 class="body-serif text-ink">{{ t("myDevelopment.committedActions") }}</h2>
                <p class="scaffold-body-small text-ink-muted">{{ weekLabel }}</p>
            </header>
            <section v-for="group in groups" :key="group.label" class="border-b border-border p-5 last:border-b-0" :aria-label="group.label">
                <h3 class="scaffold-body-small mb-3 text-ink-muted">{{ group.label }}</h3>
                <ul>
                    <li
                        v-for="action in group.actions"
                        :key="action.id ?? action.action_ref"
                        class="flex items-start gap-3 border-b border-border py-3 first:pt-0 last:border-b-0 last:pb-0">
                        <span
                            class="flex size-8 shrink-0 items-center justify-center rounded-md"
                            :class="group.withNadia ? 'bg-chip-journeys-bg text-journey-highlight-ink' : 'bg-surface-sunken text-ink-muted'"
                            aria-hidden="true">
                            <i class="bi" :class="group.withNadia ? 'bi-chat-left-fill' : 'bi-person-fill'"></i>
                        </span>
                        <span>
                            <span class="body-small block text-ink">{{ action.title }}</span>
                            <span v-if="action.timing" class="scaffold-details-small mt-1 block text-ink-muted">{{ action.timing }}</span>
                        </span>
                    </li>
                </ul>
            </section>
        </BaseCard>
    </section>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import { formatDateRange } from "~vue/utils/formatDate";
import { DateTime } from "luxon";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import type { MyDevelopmentActionPlan } from "./myDevelopmentActionPlan";

const props = defineProps<{ plan: MyDevelopmentActionPlan }>();
const { t } = useI18n();
const weekLabel = computed(() => formatDateRange(props.plan.week_start, DateTime.fromISO(props.plan.week_start).plus({ days: 6 }).toISODate(), "month-day", { year: "never" }));
const groups = computed(() =>
    [
        { label: t("myDevelopment.withNadia"), withNadia: true, actions: props.plan.actions.filter((action) => action.with_nadia) },
        { label: t("myDevelopment.onYourOwn"), withNadia: false, actions: props.plan.actions.filter((action) => !action.with_nadia) },
    ].filter((group) => group.actions.length),
);
</script>
